import React from "react";
import styled from "styled-components";

// components
import { BorderBottomLinkStyle, CustomFocusStyle } from "core/Typography";
import colors from "core/colors";
import BodyText from "core/BodyText";
import Button from "core/Button";
import breakpoints from "core/breakpoints";
import Flexbox from "core/Flexbox";
import { regular } from "core/fontStyles";

// helpers
import { Link as ReactRouterLink } from "react-router-dom";
import { convertPxToRem } from "frontend/components/helpers";
import {
    handleBottomSpacing,
    handleTopSpacing
} from "js/helpers/spacingAndFonts";

export const EduHeadingContainer = styled.div`
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        padding-left: ${convertPxToRem({ px: 15 })};
        padding-right: ${convertPxToRem({ px: 15 })};
    }
`;

export const EmailDescriptionLabel = styled(BodyText)`
    ${handleBottomSpacing({ bottomSpacing: "lg" })};
`;

export const ResponseTimeInfo = styled(BodyText)`
    ${handleBottomSpacing({ bottomSpacing: "2xl" })};
    ${handleTopSpacing({ bottomSpacing: "2xl" })};
`;

export const CancelLink = styled(ReactRouterLink)`
    ${BorderBottomLinkStyle}
    color: ${colors.secondary.oolong};
    border-color: ${colors.secondary.oolong};

    font-size: ${convertPxToRem({ px: 15 })};
    ${CustomFocusStyle}
    ${regular}
    
    &:hover {
        color: ${colors.secondary.cosmic};
        border-color: ${colors.secondary.cosmic};
    }
`;

export const ApplyButton = styled(Button).attrs({
    styleType: "cta",
    width: "50%"
})`
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        width: 70%;
    }
`;

export const ButtonContainer = styled(Flexbox).attrs({
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
})``;
